import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ColorPickerModule} from 'ngx-color-picker';

import {ToolService} from './tool.service';

import {ToolComponent} from './tool.component';
import {HeadComponent} from './head/head.component';
import {EditorComponent} from './editor/editor.component';
import {PreviewComponent} from './preview/preview.component';

@NgModule({
  imports: [
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    ColorPickerModule,
    CommonModule
  ],
  declarations: [
    ToolComponent,
    HeadComponent,
    EditorComponent,
    PreviewComponent,
  ],
  providers: [ToolService]
})
export class ToolModule {}
